export const PEOPLE_HR_ALLOWED_ROLES = ["operations", "super_admin"] as const;

export type PeopleHrAccessRole = (typeof PEOPLE_HR_ALLOWED_ROLES)[number] | string | null | undefined;

export function canAccessPeopleHrRole(role: PeopleHrAccessRole) {
  const normalized = String(role || "").trim().toLowerCase();
  return normalized === "operations" || normalized === "super_admin";
}
